import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EventService from '../../../services/EventService';
import { OfflineCache } from '../../services/OfflineCache';

function EventDetailedAndroid() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [downloading, setDownloading] = useState(false);
    const [mailing, setMailing] = useState(false);

    useEffect(() => {
        const fetchEvent = async () => {
            try {
                const response = await EventService.getEventById(id);
                setEvent(response.data);
                OfflineCache.saveEventDetail(id, response.data);
            } catch (e) {
                const cached = OfflineCache.getEventDetail(id);
                if (cached) {
                    setEvent(cached);
                } else {
                    setError('Error loading event');
                }
            } finally {
                setLoading(false);
            }
        };
        fetchEvent();
    }, [id]);

    const jumpToLandingPage = () => {
        const formattedArtistName = event.artistName.replaceAll(" ", "-").toLowerCase();
        window.open(`https://labelboost.net/events/${formattedArtistName}/${event.id}`, '_blank');
    };

    const openCheckin = () => navigate(`/events/checkin/${event.id}`);
    const openEdit = () => navigate(`/events/edit/${event.id}`);

    const downloadParticipants = async () => {
        setDownloading(true);
        try {
            const res = await EventService.getParticipantsList(event.id);
            const blob = new Blob([res.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (e) {
        } finally {
            setDownloading(false);
        }
    };

    const mailParticipants = async () => {
        setMailing(true);
        try {
            await EventService.getListWithParticipantsPerMail(event.id);
            alert('Mail sent');
        } catch (e) {
        } finally {
            setMailing(false);
        }
    };

    return (
        <div className="px-4 py-4">
            {loading ? (
                <div className="text-center py-10">Loading...</div>
            ) : !event ? (
                <div className="text-center py-10">Not found</div>
            ) : (
                <div>
                    {error ? <div className="text-red-600 mb-3">{error}</div> : null}
                    {event.imageUrl ? (
                        <img src={event.imageUrl} alt={event.name} className="w-full h-48 object-cover rounded mb-3" />
                    ) : (
                        <div className="w-full h-40 bg-gray-100 rounded mb-3 flex items-center justify-center">No Image</div>
                    )}
                    <h2 className="text-2xl font-bold mb-1">{event.name}</h2>
                    <p className="text-gray-700 mb-1">Venue: {event.venue}</p>
                    <p className="text-gray-700 mb-1">Date: {new Date(event.eventDate).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                    {event.supportInformation ? (
                        <p className="text-gray-700 mb-1">Support: {event.supportInformation}</p>
                    ) : null}
                    <p className="text-gray-700 mb-1">Sold: {event.ticketsSold}</p>
                    <p className="text-gray-700 mb-1">Available: {event.capacity - event.ticketsSold}</p>
                    <p className="text-gray-700 mb-2">Revenue: €{(event.currentRevenue / 100).toFixed(2)}</p>

                    <div className="grid grid-cols-2 gap-2 mb-3">
                        <button className="bg-blue-600 text-white rounded-md px-3 py-2 text-sm" onClick={openCheckin}>Check-In</button>
                        <button className="bg-blue-600 text-white rounded-md px-3 py-2 text-sm" onClick={openEdit}>Edit</button>
                        <button className="bg-blue-600 text-white rounded-md px-3 py-2 text-sm" onClick={jumpToLandingPage}>Landing Page</button>
                        <button className={`bg-blue-600 text-white rounded-md px-3 py-2 text-sm ${downloading ? 'opacity-50' : ''}`} onClick={downloadParticipants} disabled={downloading}>{downloading ? 'Downloading...' : 'Tickets'}</button>
                        <button className={`bg-blue-600 text-white rounded-md px-3 py-2 text-sm ${mailing ? 'opacity-50' : ''}`} onClick={mailParticipants} disabled={mailing}>{mailing ? 'Sending...' : 'Tickets (mail)'}</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default EventDetailedAndroid;


